import { z } from 'zod';
import {
	EmptyValidationMessage,
	FieldValues,
	Path,
	addDays,
	getNow,
	getTzTodayDate,
	isAfter,
	isBefore,
	mapDatePicker,
	parseIsoDateTime,
} from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { useSystemConfigurationSettings } from '../../../../app-init-data';

export const usePolicyEffectiveDateField = <TForm extends FieldValues>() => {
	const { systemConfigurationSettings } = useSystemConfigurationSettings();
	const { translate: t } = useAppPlatformContextOptions();
	const getField = ({ field }: { field: Path<TForm> }) =>
		mapDatePicker({
			field,
			label: t('members:policy-effective-date.label'),
			placeholder: t('members:policy-effective-date.placeholder'),
			fromDate: getNow(),
			toDate: addDays(getNow(), systemConfigurationSettings?.policyEffectiveDateThreshold ?? 6),
			defaultMonth: getNow(),
			isClearable: false,
			readonly: true,
		});

	const getValidation = () =>
		z.object({
			policyEffectiveDate: z
				.string({
					required_error: EmptyValidationMessage,
				})
				.refine(
					(value) => {
						if (
							(value && isBefore(parseIsoDateTime(value) as Date, getTzTodayDate())) ||
							(value && isAfter(parseIsoDateTime(value) as Date, addDays(getTzTodayDate(), 7))) ||
							!value
						)
							return false;

						return true;
					},
					{ message: EmptyValidationMessage }
				),
			policyEndDate: z.string().optional(),
		});

	return {
		getField,
		getValidation,
	};
};
